import { Body02, Headline06 } from 'Components/designSystem';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCard, PageLayout } from 'shared/components';
import styled from 'styled-components';

import { OfferPageAdditionalActions } from '../containers/OfferPageAdditionalActions';

function OffersEmpty() {
    const { t } = useTranslation('candidateOffers');

    return (
        <PageLayout>
            <ContentCard>
                <PageLayout.Content>
                    <Headline06>{ t('jobsAvailable_zero') }</Headline06>
                    <Subtitle>{ t('emptyScreenDescription') }</Subtitle>
                    <OfferPageAdditionalActions />
                </PageLayout.Content>
            </ContentCard>
        </PageLayout>
    );
}

const Subtitle = styled(Body02)`
    padding: ${ ({ theme }) => `${ theme.size.size_10 } 0 ${ theme.size.size_20 }` } 0;
    color: ${ ({ theme }) => theme.semanticColor.textTertiary };
`;

export default memo(OffersEmpty);
